import React from 'react';
import { Link } from 'react-router-dom';
import Stack from 'react-bootstrap/Stack';
import FloatingLabel from 'react-bootstrap/FloatingLabel';

function App() {
  const link = { width: '200px', height: '50px', margin: '10px', padding: '5px', color: 'red', backgroundColor: 'lightgray', textAlign: 'center' }

  return (
    <Stack>
      <FloatingLabel as='header' className='ValidateSchema-header'>
        Schema validator
      </FloatingLabel>

      <Stack direction='vertical' style={{ alignItems: 'center', margin: 200, rowGap: '50px' }}>
        <Link style={link} to='is-json-schema-valid'>Is JSON Schema Valid</Link>
        <Link style={link} to='validate-one-function-schema-n-one-payload'>Validate One Function Schema and One Payload</Link>
        <Link style={link} to='validate-schema-n-payload'>Validate schema and Payload</Link>
        <Link style={link} to='json-comparison'>JSON comparison</Link>
      </Stack>
    </Stack>
  );
}
export default App;